import { TemplateField } from './template-field';

export class CampoSolicitud {
  id: number;
  nombre: string;
  descripcion: string;
  valor: string | number | Date | any[];
  multivalue: boolean;
  tipo: string;

  constructor() { }

  toTemplateField(): TemplateField {
    const templateField = new TemplateField();
    templateField.id = this.id;
    templateField.multivalue = this.multivalue;
    templateField.nombre = this.nombre;
    templateField.tipo = this.tipo;
    templateField.value = this.valor;
    templateField.descripcion = this.descripcion;
    return templateField;
   }

}
